import React from "react";
import InputCheckbox from "../../components/InputCheckbox";
import Input from "../../components/Input";
import InputMask from "../../components/InputMask";
import InputNumberOnly from "../../components/InputNumberOnly";
import { Upload, message, Button, Row, Col, Typography, Modal } from "antd";
import { UploadOutlined, LoadingOutlined } from "@ant-design/icons";
import { setItem, removeItem, getItem } from "utils";
import PdfViewer from "../../components/PdfViewer";

import history from "../../services/history";

export default function FormSecurity({
  register,
  errors,
  control,
  onPrevious,
  getValues,
  onNext,
  loading,
}) {
  const { Text } = Typography;

  const [hasTermsRepresentation, setHasTermsRepresentation] =
    React.useState(null);

  React.useEffect(() => {
    const term = getItem("termsRepresentation");
    term && setHasTermsRepresentation(true);
  }, []);

  const [modalConfig, setModalConfig] = React.useState({});

  const handleOk = () => {
    setModalConfig((prev) => ({ ...prev, visible: false }));
  };

  const handleCancel = () => {
    setModalConfig((prev) => ({ ...prev, visible: false }));
  };

  return (
    <div key="formSecurity">
      <Row gutter={16} className="__auth-mb-25">
        <Col xs={24} sm={24}>
          <InputMask
            label="Senha"
            placeholder="Digite sua senha"
            control={control}
            name="password"
            required
            helperText="A senha deve conter 6 números"
            mask="999999"
            maskChar={null}
            error={errors.password?.message}
            type="password"
            pattern="[0-9]*"
            inputmode="numeric"
          />
        </Col>
        <Col xs={24} sm={24}>
          <InputMask
            label="Confirme sua senha"
            placeholder="Digite sua senha novamente"
            control={control}
            name="confirmPassword"
            required
            mask="999999"
            maskChar={null}
            error={errors.confirmPassword?.message}
            type="password"
            pattern="[0-9]*"
            inputmode="numeric"
          />
        </Col>

        <Col xs={24} sm={24}>
          <InputCheckbox
            label="Aceito os termos de uso"
            register={register("terms")}
            required
            name="terms"
            error={errors.terms?.message}
            adornment={
              <div className="__auth-terms">
                <a
                  className="__auth-term-item"
                  onClick={() => {
                    setModalConfig({
                      visible: true,
                      title: "Termos de Uso",
                      url: getItem("termsConditions"),
                    });
                    // getItem("termsConditions") &&
                    // window.open(getItem("termsConditions"))
                  }}
                >
                  Visualize os termos
                </a>
              </div>
            }
          />
        </Col>

        <Col xs={24} sm={24}>
          <InputCheckbox
            label="Aceito a política de privacidade e serviços"
            register={register("privacyPolicy")}
            required
            name="privacyPolicy"
            error={errors.privacyPolicy?.message}
            adornment={
              <div className="__auth-terms">
                <a
                  className="__auth-term-item"
                  onClick={() => {
                    setModalConfig({
                      visible: true,
                      title: "Política de Privacidade",
                      url: getItem("privacyPolicy"),
                    });
                    // getItem("privacyPolicy") &&
                    // window.open(getItem("privacyPolicy"))
                  }}
                >
                  Visualize os termos
                </a>
              </div>
            }
          />
        </Col>

        {hasTermsRepresentation && (
          <Col xs={24} sm={24}>
            <InputCheckbox
              label="Aceito o termo de associação"
              register={register("termsRepresentation")}
              required
              name="termsRepresentation"
              error={errors.termsRepresentation?.message}
              adornment={
                <div className="__auth-terms">
                  <a
                    className="__auth-term-item"
                    onClick={
                      () => {
                        setModalConfig({
                          visible: true,
                          title: "Termo de Associação",
                          url: getItem("termsRepresentation"),
                        });
                      }
                      // getItem("termsRepresentation") &&
                      // window.open(getItem("termsRepresentation"))
                    }
                  >
                    Visualize os termos
                  </a>
                </div>
              }
            />
          </Col>
        )}
      </Row>
      <Row gutter={16} className="__signup-bottom-button">
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-outlined"
            onClick={onPrevious}
            disabled={loading}
          >
            Voltar
          </button>
        </Col>
        <Col xs={12}>
          <button
            type="button"
            className="__auth-button-primary"
            disabled={loading}
            onClick={onNext}
          >
            {loading ? <LoadingOutlined /> : "Próximo"}
          </button>
        </Col>
      </Row>

      <Modal
        title={modalConfig.title}
        open={modalConfig.visible}
        url={modalConfig.url}
        onOk={handleOk}
        onCancel={handleCancel}
        width="700px"
        footer={[
          <Button key="back" onClick={handleCancel}>
            Fechar
          </Button>,
        ]}
      >
        <PdfViewer url={modalConfig.url}></PdfViewer>
      </Modal>
    </div>
  );
}
